
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agentic-operations/assessment",
      function () {
        return require("private-next-pages/agentic-operations/assessment.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agentic-operations/assessment"])
      });
    }
  